import type { RouteRecordRaw } from 'vue-router';
import RouteLayout from '../RouteLayout.vue';

export const dashboardRoutes: RouteRecordRaw = {
  path: 'dashboard',
  component: RouteLayout,
  children: [
    {
      path: '',
      name: 'tabs-dashboard',
      component: () => import('@/views/Dashboard.vue'),
    },
    {
      path: 'goals',
      name: 'dashboard-goals',
      component: () => import('@/views/Goals.vue'),
    },
    {
      path: 'weight',
      name: 'dashboard-weight',
      component: () => import('@/views/WeightPage.vue'),
    },
    {
      path: 'history',
      name: 'dashboard-history',
      component: () => import('@/views/DashboardHistoryPage.vue'),
    },
    {
      path: 'nutrition',
      redirect: { name: 'dashboard-history' },
    },
    {
      path: 'planning',
      name: 'dashboard-planning',
      component: () => import('@/views/PlanningPage.vue'),
    },
  ],
};
